/* eslint-disable no-useless-constructor */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as betActions from '../../actions/bet';
import Wager from './Wager';
import Payout from './Payout';
import Profit from './Profit';
import Risk from './Risk';

const mapStateToProps = function(state){
    return {
        bet: state.bet
    }
}

class Bet extends Component {
    render(){
        const {updatePayout ,updateWager } = this.props;
        const { wager, payout } = this.props.bet;
        return (
            <div>
                <Wager  
                 wager={wager.str}
                 onChange={updateWager}
                />
                <Payout 
                  payout={payout.str}
                  onChange={updatePayout}
                />
                <Profit
                 payout={payout}
                 wager={wager}
                 />
                 <Risk
                  payout={payout}
                  wager={wager}
                  />
            </div>
        )
    }
}

export default connect(mapStateToProps, betActions)(Bet);


// WEBPACK FOOTER //
// ./src/components/bet/index.js